var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"container-section-buttons"}},[_c('button',{staticClass:"button button-play",on:{"click":function($event){_vm.handleClick();
      _vm.getIconButton();}}},[_c('img',{attrs:{"id":"play","src":'/icons/' + _vm.actualButtonIcon + '.png'}})])])}
var staticRenderFns = []

export { render, staticRenderFns }